import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useState } from "react";
import { useTranslations } from "next-intl";
import { useMedia } from "react-use";
import Search from "@engineering/icons/search";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { SearchInput } from "./SearchInput";
import { SearchProvider, useSearchContext } from "./context";
import { useSubmitHandler, useSession } from "./hooks";
import { StyledForm } from "./SearchForm.styles";
import { Wrapper, Title, FormContainer, StyledButton } from "./WidgetSearchForm.styles";
import { matchError } from "./hooks/useSubmitHandler";
import { isFormError } from "./context/types";
var WidgetSearchForm = function() {
    var ref = useSearchContext(), setDate = ref.setDate, setError = ref.setError, state = ref.state;
    var t = useTranslations("features.stageLegacy.stage.searchForm");
    var submitHandler = useSubmitHandler();
    var ref1 = useSession(), trackClickTimestamp = ref1.trackClickTimestamp, removeClickTimestamp = ref1.removeClickTimestamp;
    var ref2 = useState(false), loading = ref2[0], setLoading = ref2[1];
    var isSmallWidgetWidth = useMedia("(max-width: 768px)", true);
    var isSmallWidgetHeight = useMedia("(max-height: 320px) and (max-width: 600px)", true);
    var isVerticalLayout = isSmallWidgetWidth || isSmallWidgetHeight;
    var onError = useCallback(function(error) {
        setLoading(false);
        removeClickTimestamp();
        var ref = matchError(error), kind = ref.type, message = ref.message;
        if (isFormError(kind)) {
            setError({
                kind: kind,
                message: message
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleSearchSubmit = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        trackClickTimestamp();
                        return [
                            4,
                            submitHandler(state, "", function() {
                                return setLoading(false);
                            }, onError, true)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSearchSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = _async_to_generator(function(event) {
            return _ts_generator(this, function(_state) {
                event.preventDefault();
                handleSearchSubmit();
                return [
                    2
                ];
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    if (!state) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            /*#__PURE__*/ _jsx(Title, {
                children: t("title")
            }),
            /*#__PURE__*/ _jsx(StyledForm, {
                onSubmit: handleSubmit,
                id: "search",
                role: "search",
                target: "_blank",
                children: /*#__PURE__*/ _jsxs(FormContainer, {
                    children: [
                        /*#__PURE__*/ _jsx(SearchInput, {
                            id: "dep",
                            history: state.history,
                            direction: "departure",
                            onServiceNumbersSubmit: handleSearchSubmit,
                            label: t("departure.label"),
                            placeholder: t("departure.placeholder"),
                            icon: /*#__PURE__*/ _jsx(Search, {})
                        }),
                        /*#__PURE__*/ _jsx(UiLegacy.DateRangePicker, {
                            from: new Date(state.depDate),
                            to: new Date(state.destDate),
                            error: state.dateError || "",
                            onDatesChange: function(dates) {
                                setDate("departure", dates.from);
                                setDate("destination", dates.to);
                            },
                            size: "small",
                            vertical: isVerticalLayout
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(StyledButton, {
                                type: "submit",
                                id: "find",
                                size: "small",
                                loading: loading,
                                fullWidth: true,
                                children: t("button.label")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var WidgetSearchFormWithContext = function(_param) /*#__PURE__*/ {
    var formProps = _extends({}, _param);
    return _jsx(SearchProvider, {
        children: /*#__PURE__*/ _jsx(WidgetSearchForm, _object_spread({}, formProps))
    });
};
export { WidgetSearchFormWithContext as WidgetSearchForm };
